import ImageMessage from "@frameworks/web/components/generic/Login/ImageMessage";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import React from "react";
import { Row, Col } from "react-bootstrap";
import resetpassword from "../../../../assets/images/generic/passwordreset.svg";
import DeviceContext from "@frameworks/web/components/generic/customHooks/indentifyDevice";
import { useLocation, useNavigate } from "react-router-dom";
import di from "@frameworks/web/components/features/LoginFlow/di/servicelocator";
import { handleNavigateUrl, loginScreenState } from "../constant";
const PasswordResetMsg = (props) => {
    const device = DeviceContext();
    const location = useLocation();
    const navigate = useNavigate();
    let backToLogin = () => {
        di.login.flushLoginReducers();
        if (props.helpFlowPopup) {
            props.helpFlowPopup(loginScreenState.LOGIN);
        }
        else {
            navigate(handleNavigateUrl("/login", props === null || props === void 0 ? void 0 : props.redirectUrlFromQueryParams), {
                replace: true,
            });
        }
    };
    return (React.createElement("div", { className: "imageblockSection p-3 pb-md-3 pb-5 bg-white" },
        React.createElement(Row, { className: "d-flex justify-content-center align-items-center" },
            React.createElement(Col, { lg: 12 },
                React.createElement(ImageMessage, { title: (device === null || device === void 0 ? void 0 : device.isDesktop) ? " " : props.title, image: resetpassword, message: props.message })),
            React.createElement(Col, { lg: 9, className: "mt-5" },
                React.createElement(EdButton, { value: "Back to Login", className: "w-100", btnTyp: "midnight-blue", onClick: backToLogin })))));
};
export default PasswordResetMsg;
